export const ENVIRONMENT_PRODUCTION = 'production'
export const ENVIRONMENT_NONPROD = 'nonprod'
export const ENVIRONMENT_DEVELOPMENT = 'development'

export const SCENARIO_CLASS_NAME = 'Scenario'

//Scenario
export const SCENARIO_TYPE = 'Scenario'
export const CATEGORY_TYPE = 'Category'

//Context  Domain
export const PORT_DOMAIN = 'PORT'
export const TERMINAL_DOMAIN = 'TERMINAL'
export const SMOKE_DOMAIN = 'SMOKE'
export const RAIL_DOMAIN = 'RAIL'

export const LIST_VIEW_MODES = {
  TILE: 'tile',
  LIST: 'list',
}

//ICommandResult
export enum COMMAND_STATUS {
  OK = 'OK',
  FAILED = 'FAILED',
  NOTFOUND = 'NOTFOUND',
}

export const ARCHIVED = 'ARCHIVED'
export const UNARCHIVED = 'UNARCHIVED'

export const LOCKED = 'LOCKED'
export const UNLOCKED = 'UNLOCKED'

export const DESCRIPTION_LENGTH = 1024
export const NAME_LENGTH = 255

export const CONTEXT = 'context'
export const SCENARIO_CONTEXT = 'scenariocontext'
export const SCENARIO_CONTEXT_ID = 'scenariocontextid'
